/**
 * Utility functions for number formatting with separator
 */

/**
 * Format number with thousand separator (comma)
 * @param {number|string} value - The number to format
 * @returns {string} Formatted number with separator
 */
export const formatNumberWithSeparator = (value) => {
  if (value === null || value === undefined || value === '') {
    return '';
  }
  
  // Convert to string and remove any existing separators
  const numStr = String(value).replace(/,/g, '');
  
  // Check if it's a valid number
  if (isNaN(numStr) || numStr === '') {
    return '';
  }
  
  // Convert to integer (remove decimals)
  const num = Math.floor(Number(numStr));
  
  // Format with comma separator
  return num.toLocaleString('en-US');
};

/**
 * Parse formatted number (remove separator)
 * @param {string} value - The formatted string
 * @returns {number|null} Parsed number or null
 */
export const parseNumberFromFormatted = (value) => {
  if (!value || value === '') {
    return null;
  }
  
  // Remove all non-digit characters except minus sign
  const cleaned = String(value).replace(/[^\d-]/g, '');
  
  if (cleaned === '' || cleaned === '-') {
    return null;
  }
  
  const num = parseInt(cleaned, 10);
  
  return isNaN(num) ? null : num;
};

/**
 * Formatter function for InputNumber component
 * @param {number} value - The number value
 * @returns {string} Formatted string with separator
 */
export const numberFormatter = (value) => {
  if (value === null || value === undefined || value === '') {
    return '';
  }
  return formatNumberWithSeparator(value);
};

/**
 * Parser function for InputNumber component
 * @param {string} value - The formatted string
 * @returns {number|null} Parsed number
 */
export const numberParser = (value) => {
  return parseNumberFromFormatted(value);
};

